// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1KnYp","heading-space":"_7f1-P"};